
import { Card, CardContent } from "@/components/ui/card";
import { InfoIcon, Target, FileText, CheckCircle } from "lucide-react";

export const MarkschemeHelpSection = () => {
  return (
    <Card className="bg-blue-50 dark:bg-blue-950/30 border-blue-200 dark:border-blue-800">
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <InfoIcon className="h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
          <div className="space-y-3">
            <h4 className="font-medium text-blue-900 dark:text-blue-100">
              Creating Effective Assessment Criteria
            </h4>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
              <div className="flex items-start gap-2">
                <Target className="h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-blue-800 dark:text-blue-200">Criterion Name</p>
                  <p className="text-blue-700 dark:text-blue-300">Keep it specific and measurable</p>
                  <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">e.g., "Technical Accuracy", "Code Quality"</p>
                </div>
              </div>
              
              <div className="flex items-start gap-2">
                <FileText className="h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-blue-800 dark:text-blue-200">Description</p>
                  <p className="text-blue-700 dark:text-blue-300">Explain what to evaluate and how</p>
                  <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">Include scoring guidelines</p>
                </div>
              </div>
              
              <div className="flex items-start gap-2">
                <CheckCircle className="h-4 w-4 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-medium text-blue-800 dark:text-blue-200">Points</p>
                  <p className="text-blue-700 dark:text-blue-300">Weight by importance</p>
                  <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">Higher points = more important</p>
                </div>
              </div>
            </div>
            
            <div className="pt-2 border-t border-blue-200 dark:border-blue-800">
              <p className="text-xs text-blue-600 dark:text-blue-400">
                <strong>Tip:</strong> Break complex questions into 2-4 specific criteria for better evaluation consistency.
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
